import React from "react";
import Navbar from "../../assets/Navbar/Navbar";
import Footer from "../../assets/Footer/Footer";
// import '../Work.css';

// import "../Learning Outcome/LO.css"; // Import the CSS file

import { useNavigate } from "react-router-dom";
// import gif1 from "../../assets/Images/bag.GIF";
import feed1 from "../../assets/Images/feedback-pics/1.png";
import feed3 from "../../assets/Images/feedback-pics/3.png";
import feed7 from "../../assets/Images/feedback-pics/7.png";
import feed12 from "../../assets/Images/feedback-pics/12.png";
import feed14 from "../../assets/Images/feedback-pics/14.png";
import feed16 from "../../assets/Images/feedback-pics/16.png";
import feedp1 from "../../assets/Images/feedback-pics/p1.png";
import feedp2 from "../../assets/Images/feedback-pics/p2.png";
import feedp3 from "../../assets/Images/feedback-pics/p3.png";
import feedp4 from "../../assets/Images/feedback-pics/p4.png";
import feedp5 from "../../assets/Images/feedback-pics/p5.png";
import feedp6 from "../../assets/Images/feedback-pics/p6.png";
import feedp7 from "../../assets/Images/feedback-pics/p7.png";




import BreadcrumbHeader from "../../assets/Breadcrumbs/Breadcrumbs";







import Slideshow from "../../assets/Slideshow/Slideshow"; 





const Lo5Feedback = () => {
    const navigate = useNavigate();

    const images = [feed1, feed3, feed7, feed12, feed14, feed16, feedp1, feedp2, feedp3, feedp4, feedp5, feedp6, feedp7];
    

    return (
        <div className="page-container">
            <Navbar />
            <div className="content-lo5-headings">
                <h1>Feedback</h1>
                <p>Throughout this semester I have to be active in asking for feedback</p>

                
            </div>

            <div className="line"></div>
            <div style={{ padding: '0.1rem 7.5rem' }}>
                                                    <BreadcrumbHeader />
            </div>
            <div className="content-lo5">
                <div className="content-lo5-feedback">
                    <div className="content-lo5-feedback-text">
                    <h1>Feedback that I have gathered</h1>
                        <p>
                            During this semester I have to ask for feedback for both personal and group situations, doing feedback
                            help me in recognizing what was working well and what need improvement. It also taught me how to reflect more 
                            on my own work. Instead of seeing feedback as criticism, I started viewing it as a way to grow and push my ideas further.
                            One of my goals is also to ask for more feedback because it could help me better in improving
                        </p>

                        <h2>Why is feedback important?</h2>
                        <p>
                            Doing feedback helps making my work closer to what I want to achieve, there were a few times that it help me realized what 
                            I could do to improve and even make my product better, it also give me a new point of view and perspective that I didn't see while doing my work / task.
                        </p>
                        <h2>Feedbacks that helps me improved my products</h2>
                        <ul>
                            <li>Frank's feedback on improving my navigation accessibility for user experience on this portfolio, from this feedback I research a bit about using breadcrumbs for my website</li>
                            <li>Amer's feedback about how I can structure the layout my website during the first concept and ideation phase</li>
                            <li>Josh's feedback on how I can manage resources for the 3D model so it wouldnt have to much polygons to not affect the web performance</li>
                            <li>Jan's feedback on how I should learn about the Uncanny Valley, improving how I could design my model and creativity for the next products I want to make</li>
                            <li>Chris's feedback on the poster and mascot, making this product not only seen but also experienced</li>
                        </ul>
                        
                        
                        
                    </div>

                    <div className="content-lo5-feedback-slideshow">
                        <Slideshow images={images} />

                    </div>

                    
                </div>
            </div>

            <Footer />
            </div>
    );
};

export default Lo5Feedback;